import { makeAutoObservable } from 'mobx'
import type { AnalyticsChartType, AnalyticsChartPeriod } from 'entities/Analytics'

export class ChartFilterStore {
  period: AnalyticsChartPeriod = 'week'
  chartType: AnalyticsChartType = 'line'

  constructor() {
    makeAutoObservable(this)
  }

  get params() {
    return {
      period: this.period,
      chartType: this.chartType,
    }
  }

  setPeriod = (period: AnalyticsChartPeriod) => {
    this.period = period
  }

  setChartType = (chartType: AnalyticsChartType) => {
    this.chartType = chartType
  }

  reset = () => {
    this.period = 'week'
    this.chartType = 'line'
  }

  dispose = () => {
    this.reset()
  }
}
